export default {"src":"/_next/static/media/Group_3.61b6e4be.svg","height":163,"width":130,"blurWidth":0,"blurHeight":0};